export default "__VITE_ASSET__5a918548__"